import React, { useState, useEffect } from 'react';

const ReadMoreText = ({ text, maxLength = 100 }) => { // Default maxLength to 100 characters
  const [isExpanded, setIsExpanded] = useState(false);
  const [displayText, setDisplayText] = useState('');

  useEffect(() => {
    if (text.length <= maxLength) {
      setDisplayText(text);
    } else {
      setDisplayText(isExpanded ? text : `${text.substring(0, maxLength)}...`);
    }
  }, [text, maxLength, isExpanded]);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  if (!text) {
    return null; // Or some placeholder if text is not available
  }

  return (
    <div>
      <span className="text-secondary-light fw-medium d-block justify-text">
        {displayText} {text.length > maxLength && (
        <button onClick={toggleReadMore} className="btn btn-link p-0">
          {isExpanded ? 'Read Less' : 'Read More'}
        </button>
      )}
      </span>
     
    </div>
  );
};

// How to use it in your component where you have profileData:
// Assuming profileData.testimony exists

// const YourParentComponent = ({ profileData }) => {
//   return (
//     <div>
//       {/* Other parts of your component */}
//       {profileData && profileData.testimony && (
//         <ReadMoreText text={profileData.testimony} maxLength={150} />
//       )}
//       {/* Other parts of your component */}
//     </div>
//   );
// };

export default ReadMoreText;